module.exports = __webpack_public_path__ + "static/media/animal_03.ead27f97.png";